import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Footnote.module.scss';

const Footnote = ({ text, children, className }) => {
  const Component = text;

  return (
    <p className={cn(className, styles.container)}>
      {children ? children : text}
    </p>
  );
};

Footnote.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

export default Footnote;
